<template>
    <div class="card">
        <div class="card-header d-flex justify-content-between align-items-center">
            <div class="font-weight-bold">
                Assinatura
            </div>

            <div>
                <b-button @click="canShow = !canShow" variant="default" size="sm">
                    <i class="fas fa-minus" v-if="canShow"></i>
                    <i class="fas fa-plus" v-else></i>
                </b-button>
            </div>
        </div>
        <div class="card-body" v-show="canShow">
            <div v-if="modeEdition">
                <subscription-form @updated="updateSubscription" @cancel="setModeEdition(false)" />
            </div>
            <div v-else>
                <subscription-panel @cancel="setModeEdition(true)"></subscription-panel>
            </div>
        </div>
    </div>
</template>

<script>
import SubscriptionForm from './Form';
import SubscriptionPanel from './Panel';
import SubscriptionCancel from './Cancel';

export default {
    components: {
        SubscriptionForm,
        SubscriptionPanel,
        SubscriptionCancel
    },
    data() {
        return {
            modeEdition: false,
            canShow: true
        }
    },
    created() {
        this.setModeEdition(false);
    },
    methods: {
        setModeEdition(status) {
            this.modeEdition = status;
        },

        updateSubscription() {
            this.setModeEdition(false);

            this.$root.$emit('reloadReceipts');

            this.$root.$emit('reloadCancels');
        }
    }
}
</script>

<style scoped>

</style>
